/** Semantic color tones for typography */
export type TypographyTone =
  | "default"
  | "subtle"
  | "subtext"
  | "disabled"
  | "inverse"
  | "inherit"
  | "negative"
  | "positive"
  | "warning"
  | "informative";

/** Tone variant classes for CVA */
export const toneVariants = {
  default: "text-text-default",
  subtle: "text-text-subtle",
  subtext: "text-text-subtext",
  disabled: "text-text-disabled",
  inverse: "text-text-inverse",
  inherit: "text-inherit",
  negative: "text-negative",
  positive: "text-positive",
  warning: "text-text-warning",
  informative: "text-text-informative",
} as const satisfies Record<TypographyTone, string>;

/** HTML heading elements */
export type HeadingElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

/** Text alignment options */
export type TypographyAlign = "start" | "center" | "end";

/** Alignment variant classes for CVA */
export const alignVariants = {
  start: "text-start",
  center: "text-center",
  end: "text-end",
} as const satisfies Record<TypographyAlign, string>;

/** Extended alignment for body text (includes justify) */
export type TextAlign = TypographyAlign | "justify";

/** Extended alignment variant classes for Text component */
export const textAlignVariants = {
  ...alignVariants,
  justify: "text-justify",
} as const satisfies Record<TextAlign, string>;

/** Truncate variant for single-line ellipsis */
export const truncateVariants = {
  true: "truncate",
  false: "",
} as const;

export const typographyWeightVariants = {
  regular: "font-(number:--font-weight-regular)",
  medium: "font-(number:--font-weight-medium)",
  semibold: "font-(number:--font-weight-semibold)",
  bold: "font-(number:--font-weight-bold)",
} as const;

export const italicVariants = {
  true: "italic",
  false: "not-italic",
} as const;

/** Line clamp variants for multi-line truncation */
export const lineClampVariants = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
} as const;
